import { AlertBar, FormItem } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

export const BasicAuthSettings = (): ReactElement => {
	return (
		<FormItem>
			<AlertBar
				kind="warning"
				isInline
				isDismissable={false}
			>
				{localize("_BasicAuthWarningText")}
			</AlertBar>
		</FormItem>
	);
};
BasicAuthSettings.displayName = "BasicAuthSettings";